var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Checking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 51h28v3H41v-3zm0-14v3h28v-3H41zm0 24h16v-3H41v3zm16-17H41v3h16v-3zM15.88 28.33L13 31.16l8.71 8.68 20.65-21-2.8-2.84-17.83 18.16-5.85-5.83zM31 44H10V21h18.12l5.22-4H6v31h29V32l-4 4.15V44z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Checking.11ceb2ab.svg";
export { SvgJ2Checking as ReactComponent };